var app = angular.module('miniRegistration', ['ngAnimate','pop.directives']);

app.controller('MainCtrl', function($scope, regService, $rootScope) {
	var timeout,
		$message = $('#message');

	$rootScope.apiURL = "https://api.pop.co";
	$rootScope.ajax = false;

	$scope.selectedDomain = null;
	$scope.domainAvailable = null;
	$scope.firstSuggestion = false;
	$scope.suggestions = [];
	$scope.success = false;
	$scope.error = false;

	$scope.shareText = escape(shareText);
	$scope.shareUrl = "";

	$scope.formData = {};
	$scope.formData.comm_pref = "email";
	$scope.formData.confirm_terms = 1;
	$scope.formData.username = "empty";
	$scope.formData.bundle = "dotco-hackathon";

	if (typeof POP.registrationServiceSettings != 'undefined') {
		$scope.formData.services = POP.registrationServiceSettings;
		void 0;
	}

	$scope.$watch('formData.domain', function(viewvalue) {
		$scope.success = false;
		$scope.error = false;
		$scope.domainAvailable = null;

		if (typeof viewvalue != 'undefined') {
			if (!viewvalue.length) {
				$scope.selectedDomain = null;
				$scope.suggestions = [];
			} else if (viewvalue.length > 2) {
				$scope.selectedDomain = null;
				$scope.suggestions = [];
				
				if (timeout) {
					clearTimeout(timeout);
				}

				timeout = setTimeout(function() {
					$scope.checkDomain();
				}, 750);
			}
		}
	});

	$scope.setSelectedDomain = function(domain) {
		$scope.selectedDomain = domain;
	}

	$scope.checkSelectedDomain = function(domain) {
		$scope.domainAvailable = null;
		$scope.suggestions = []; 
		$scope.firstSuggestion = false;
		$scope.exactMatch = false;

		$scope.formData.domain = domain;
	}

	$scope.checkDomain = function() {
		$scope.error = false;
		$scope.success = false;

		regService.checkDomain($scope.formData.domain).then(function(resp) {
			// handle only returning a single available domain (no suggestions)
			if (!resp.similar_domains || !resp.similar_domains.length) {
				$scope.domainAvailable = resp.available;
				$scope.suggestions = [];
				$scope.firstSuggestion = false;
				$scope.exactMatch = false;

				// handle error messaging
				if (resp.code && resp.code != 200) {
					POP.Message.response($message, resp);
					$scope.error = true;
				}

				return;
			}

			$scope.domainAvailable = resp.available;
			$scope.firstSuggestion = resp.similar_domains.shift();
			$scope.suggestions = resp.similar_domains;
			$scope.exactMatch = $scope.firstSuggestion.Domain == $scope.formData.domain || ($scope.firstSuggestion.Domain == $scope.formData.domain + '.co');

			if (!$scope.exactMatch) {
				$scope.suggestions.unshift($scope.firstSuggestion);
			}
		}, function(err){
			$scope.error = true;
			$scope.domainAvailable = false;
			$scope.notAvailable = true;

			POP.Message.response($message, {code:555});

			void 0;
		});
	}

	$scope.registerDomain = function() {
		$scope.error = false;
		$scope.success = false;
		$scope.formData.domain = $scope.selectedDomain.Domain;

		// if we don't yet have a domain service, add our default
		if (!$scope.formData.services.domain) {
			$scope.formData.services.domain = 'domain-' + $scope.selectedDomain.TLD;
		}

		regService.registerDomain($scope.formData)
			.then(function(resp) {
				if (resp.code === 200) {
					$scope.success = true;
					$scope.shareText = $scope.shareText.replace('xyz', $scope.formData.domain);
					$scope.shareUrl = escape('http://www.' + $scope.formData.domain);
				} else {
					$scope.error = true;
					POP.Message.response($message, resp);
				}
			}, 
			function(err) {
				$scope.error = true;
				
				POP.Message.response($message, {code:555});

				void 0;
			}
		);
	}
});
					
app.factory('regService', function($http, $q, $rootScope) {
	var service = {},
		deferred;
			
	service.checkDomain = function(domain) {
		if (deferred) {
			deferred.resolve();
		}

		deferred = $q.defer();

		$rootScope.ajax = true;
			
		$http({
			url:$rootScope.apiURL + '/domains/available',
			method: 'POST',
			data:JSON.stringify({ "domain": domain, "any_tld": POP.searchTlds }),
			timeout: deferred.promise,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			}
		})
		.success(function(resp) {
			$rootScope.ajax = false;
			deferred.resolve(resp);
		}).
		error(function(err) {
			$rootScope.ajax = false;
			deferred.reject();
		});

		return deferred.promise;
	}

	/**
	 * Special helper for domain registration of LPs.
	 */
	service.registerDomain = function($formData) {
		if (deferred) {
			deferred.resolve();
		}

		deferred = $q.defer();

		$rootScope.ajax = true;

		var formData = angular.copy($formData);

		$http({
			method: 'POST',
			timeout: deferred.promise,
			url: $rootScope.apiURL + '/register/simple',
			data: JSON.stringify(formData),
		})
		.success(function(resp) {
			$rootScope.ajax = false;
			deferred.resolve(resp);
		})
		.error(function(err){
			$rootScope.ajax = false;
			deferred.reject();
		});

		return deferred.promise;
	};
			
	return service;		
});

app.directive('ngEnter', function () {
	return function (scope, element, attrs) {
		element.bind("keydown keypress", function (event) {
			if (event.which === 13) {
				scope.$apply(function() {
					scope.$eval(attrs.ngEnter);
				});

				event.preventDefault();
			}
		});
	};
});
